import { accountAccessService } from "@services/accountAccessService";
import { sessionService } from "@services/sessionService";
import { tokenStore } from "@services/tokenStore";
import { Account } from "@wingspanhq/wingspan-api-sdk";
import { useCallback } from "react";
import { useModalSelectAccounts } from "../components/ModalSelectAccounts/useModalSelectAccounts";

export const useSelectSessionAccount = () => {
  const modalSelectAccounts = useModalSelectAccounts();

  return useCallback(
    async (accounts: Account[]) => {
      if (accountAccessService.getImpersonationState().isImpersonated) {
        return;
      }

      const personId = tokenStore.getIdentity()?.personId;
      const preferredAccountId = personId
        ? tokenStore.getPreferredAccountId(personId)
        : undefined;
      const preferredAccount = accounts.find(
        account => account.id === preferredAccountId
      );

      const unambiguousAccount =
        preferredAccount ?? (accounts.length === 1 ? accounts[0] : undefined);

      if (unambiguousAccount) {
        await sessionService.switchAccount(unambiguousAccount.id!);
        return;
      }

      await modalSelectAccounts.open({});
    },
    [modalSelectAccounts]
  );
};
